export default __webpack_public_path__ + "static/media/right-chevron.bd00ce3c.png";